var map = {
	"./arrow-down-blue.svg": 919,
	"./arrow-down-grey.svg": 920,
	"./arrow-right-white.png": 921,
	"./arrow-right.svg": 922,
	"./artwork_audio.svg": 432,
	"./artwork_gif.svg": 433,
	"./artwork_img.svg": 434,
	"./artwork_video.svg": 435,
	"./audio.png": 436,
	"./bake.png": 923,
	"./blue-loader.svg": 300,
	"./bsc.png": 301,
	"./cancle.png": 302,
	"./circle-grey.svg": 924,
	"./circle.svg": 925,
	"./coinbaseWalletIcon.svg": 189,
	"./complete.png": 303,
	"./dropdown-blue.svg": 926,
	"./dropdown.svg": 927,
	"./dropup-blue.svg": 928,
	"./ethereum-logo.png": 929,
	"./fortmaticIcon.png": 190,
	"./icon-bnb.png": 304,
	"./link.svg": 930,
	"./magnifying-glass.svg": 931,
	"./menu.svg": 932,
	"./metamask.png": 305,
	"./play.png": 933,
	"./plus-blue.svg": 934,
	"./plus-grey.svg": 935,
	"./portisIcon.png": 191,
	"./prev.png": 234,
	"./question-mark.svg": 936,
	"./question.svg": 937,
	"./report.png": 938,
	"./search.png": 939,
	"./search.svg": 306,
	"./spinner.svg": 940,
	"./token-list/lists-dark.png": 307,
	"./token-list/lists-light.png": 308,
	"./trustWallet.png": 941,
	"./walletConnectIcon.svg": 192,
	"./x.svg": 942
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 284;